
import { ColumnConfig } from "@/components/tables/ReusableTablePage";
import { AccessRequest, UserProfile } from "@/types";
import { UserCheck, UserX } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export const getUsersColumns = (): ColumnConfig[] => {
  return [
    {
      key: 'email',
      header: 'Email',
      sortable: true,
      width: '200px',
      render: (value) => value || '-',
    },
    {
      key: 'first_name',
      header: 'First Name',
      sortable: true,
      width: '120px',
      render: (value) => value || '-',
    },
    {
      key: 'last_name',
      header: 'Last Name',
      sortable: true,
      width: '120px',
      render: (value) => value || '-',
    },
    {
      key: 'role',
      header: 'Role',
      sortable: true,
      width: '100px',
      render: (value, row) => {
        if ('status' in row) {
          return <Badge variant="secondary">Request</Badge>;
        }
        const profile = row as UserProfile;
        return <Badge variant="outline">{profile.role || "customer"}</Badge>;
      },
    },
    {
      key: 'status',
      header: 'Status',
      sortable: true,
      width: '140px',
      render: (value, row) => {
        if ('status' in row) {
          const request = row as AccessRequest;
          const status = request.status || 'pending';
          return (
            <Badge variant={status === 'approved' ? 'default' : status === 'rejected' ? 'destructive' : 'secondary'}>
              {status === 'approved' && <UserCheck className="w-3 h-3 mr-1" />}
              {status === 'rejected' && <UserX className="w-3 h-3 mr-1" />}
              {status.charAt(0).toUpperCase() + status.slice(1)}
            </Badge>
          );
        }
        
        const profile = row as UserProfile;
        const isBanned = profile.is_banned || profile.isBanned;
        const isApproved = profile.is_approved || profile.isApproved;
        
        if (isBanned) return <Badge variant="destructive">Banned</Badge>;
        if (!isApproved) return <Badge variant="secondary">Pending Approval</Badge>;
        return <Badge variant="default">Active</Badge>;
      },
    },
    {
      key: 'company_name',
      header: 'Company',
      sortable: true,
      width: '150px',
      render: (value) => value || '-',
    },
    {
      key: 'phone',
      header: 'Phone',
      sortable: true,
      width: '120px',
      render: (value) => value || '-',
    },
    {
      key: 'created_at',
      header: 'Created',
      type: 'date',
      sortable: true,
      width: '100px',
      render: (value) => {
        if (!value) return '-';
        try {
          return new Date(value).toLocaleDateString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          });
        } catch (e) {
          console.error('Error formatting date:', e);
          return '-';
        }
      },
    },
  ];
};
